<template>
  <v-card
    class="mt-5 text-left"
    @click="$router.push(`/package-details/${pkg.id}`)"
    :disabled="hasPackage"
  >
    <v-card-text>
      <v-row align="center" no-gutters>
        <!-- <v-col cols="auto" align-self="start">
          <v-avatar size="80" rounded="lg">
            <img :src="pkg.attributes['schoolId'].get('signature')" alt="" />
          </v-avatar>
        </v-col> -->
        <v-col class="mx-2">
          <h2 class="black--text font-weight-medium mb-2">
            <v-avatar size="40" rounded="lg" class="mr-1" v-if="pkg.attributes['schoolId'].get('associatedId').get('profilePicture')">
              <img :src="pkg.attributes['schoolId'].get('associatedId').get('profilePicture')" alt="" />
            </v-avatar>
             <v-avatar size="40" rounded="lg" class="mr-1" v-else>
              <img rc="https://thedriverx.com/assets/images/user.png" alt="" />
            </v-avatar>
            {{ pkg.attributes["schoolId"].get("name") }}
          </h2>
          <p>
            {{ pkg.attributes["schoolId"].get("addressTwo") }},
            {{ pkg.attributes["schoolId"].get("city") }},
            {{ pkg.attributes["schoolId"].get("postalCode") }}
          </p>
          <p class="mb-0">
            This package includes : <strong>{{ pkg.attributes["course"] === true ? 'Online course':'' }}</strong>,<strong>{{ pkg.attributes["roadtest_booking"] === true ? ' Road test booking':'' }}</strong> <strong>{{ pkg.attributes["certificate"] === true ? 'and full registration with certificate':'' }}</strong>
          </p>
        </v-col>
        <v-col cols="auto">
          <h2>${{ pkg.attributes["price"] }}</h2>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    pkg: {
      type: Object,
      required: true
    },
    hasPackage: {
      type: Boolean,
      default: false
    }
  }
}
</script>
